module.exports = __webpack_public_path__ + "img/moto.76e7ba14.png";